import {numberFormatter} from "@/service/NumberFormatter";
import TraderPayoutLimitDTO from "@/models/TraderPayoutLimitDTO";

type BalanceEntry = {
  currency: string;
  formattedAmount: string;
};

function balanceEntries(
    balances: Record<string, string> | null | undefined,
    currencies?: string[] | null,
): BalanceEntry[] {
  const map = balances ?? {};
  const list = currencies?.length ? currencies : Object.keys(map);

  return list
      .map((currency) => ({
        currency,
        formattedAmount: numberFormatter.formatNumber(parseFloat(map[currency] ?? '0'), 2) ?? '0',
      }))
      .sort((a, b) => a.currency.localeCompare(b.currency));
}

export function parsePayoutLimitResponse(data: TraderPayoutLimitDTO | null | undefined): TraderPayoutLimitDTO | null {
  if (!data || !Object.prototype.hasOwnProperty.call(data, 'availableByCurrency') || data.availableByCurrency == null) {
    return null;
  }

  return data;
}

export function payoutLimitEntries(availableByCurrency: Record<string, string> | null | undefined) {
  return balanceEntries(availableByCurrency);
}

export function payoutSettingsBalanceEntries(
    balanceByCurrency: Record<string, string> | null | undefined,
    currencies?: string[] | null,
) {
  return balanceEntries(balanceByCurrency, currencies);
}

export function payoutAcceptHint(limit: TraderPayoutLimitDTO | null, currency: string) {
  const balance = limit?.availableByCurrency?.[currency];
  if (balance === undefined) {
    return null;
  }

  return {
    amount: numberFormatter.formatNumber(parseFloat(balance), 2) ?? balance,
    currency,
  };
}
